import { render, staticRenderFns } from "./ApprecordView.vue?vue&type=template&id=77e6bf58&scoped=true"
import script from "./ApprecordView.vue?vue&type=script&lang=js"
export * from "./ApprecordView.vue?vue&type=script&lang=js"
import style0 from "./ApprecordView.vue?vue&type=style&index=0&id=77e6bf58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e6bf58",
  null
  
)

export default component.exports